import { ModalTransition } from '@atlaskit/modal-dialog'
import { setGlobalTheme } from '@atlaskit/tokens'
import { sanitizeUrl } from '@braintree/sanitize-url'
import * as React from 'react'
import { DownloadInProgressModal } from '../components/DownloadInProgressModal'
import { ExcelDialog } from '../components/ExcelDialog'
import { ExportToContext } from '../context/ExportToContext'
import { SendScreenEvent } from '../services/AnalyticsClient'

export function ExportToExcel({ downloadInProgress, uploadInProgress }) {
  const [downloadUrl, setDownloadUrl] = React.useState()
  const [openOnlineUrl, setOpenOnlineUrl] = React.useState()
  const [openingOnline, setOpeningOnline] = React.useState()

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search)

    const colorMode = params.get('colorMode')

    if (colorMode) {
      setGlobalTheme({ colorMode })
    }
  }, [])

  const { jiraSourcePage, offlineFileInfo, onlineFileInfo } = React.useContext(ExportToContext)

  React.useEffect(() => {
    if (downloadInProgress && offlineFileInfo) {
      setDownloadUrl(offlineFileInfo.contentUrl)
    }
    if (uploadInProgress && onlineFileInfo) {
      setDownloadUrl(onlineFileInfo.contentUrl)
    }

    if (onlineFileInfo) {
      if (onlineFileInfo.authRequired) {
        const searchParamsExceptIssues = new URL(window.location)

        // remove useless search param in order to avoid extremely long url
        searchParamsExceptIssues.searchParams.delete('issues')
        const finalRedirectUrl = `${window.location.origin}/upload-in-progress${searchParamsExceptIssues.search}`
        const effectiveAuthFlowUrl = new URL(window.location.origin + onlineFileInfo.authFlowUrl)

        // allowed auth flow clientID
        effectiveAuthFlowUrl.searchParams.set('authClientId', 'openInClientApp')
        // redirect URL is whitelisted on backend for clientId=openInClientApp
        effectiveAuthFlowUrl.searchParams.set('redirectTo', finalRedirectUrl)

        setOpenOnlineUrl(effectiveAuthFlowUrl)
      } else {
        setOpenOnlineUrl(onlineFileInfo.contentUrl)
      }
    }
  }, [downloadInProgress, offlineFileInfo, onlineFileInfo, uploadInProgress])

  React.useEffect(() => SendScreenEvent('exportToExcelScreen'), []) // run it once

  if (!jiraSourcePage) return null // empty context

  return (
    <ModalTransition>
      {downloadUrl || openingOnline ? (
        <DownloadInProgressModal downloadUrl={downloadUrl} />
      ) : (
        <ExcelDialog
          openOnlineUrl={openOnlineUrl}
          setDownloadUrl={setDownloadUrl}
          setOpeningOnline={setOpeningOnline}
        />
      )}
    </ModalTransition>
  )
}
